// Guide videos are always requested by the visitor. Their Shopify markup is
// inert until then, including for visitors who request reduced motion.
if (!customElements.get('pure-welcome-media')) {
  customElements.define('pure-welcome-media', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-welcome-play]');
      this.onPlay = () => {
        if (!this.video) {
          const template = this.querySelector('template');
          // Avoid initializing video in the inert template document on WebKit.
          const fragment = template && this.ownerDocument.importNode(template.content, true);
          this.video = fragment?.querySelector('video');
          if (!this.video) return;
          this.controller = window.PureVideo?.prepare(this.video, { separatePoster: true });
          this.append(fragment);
          this.video.addEventListener('playing', () => this.classList.add('is-playing'));
        }
        this.video.play().catch(() => { this.video.controls = true; });
      };
      this.button?.addEventListener('click', this.onPlay);
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onPlay);
      this.controller?.destroy();
      this.video?.pause();
      this.video?.remove();
      this.video = null;
    }
  });
}

// Measure once per resize/font change; hover animates transforms and opacity
// and the requested PDP width transition. Without this enhancement, all category descriptions remain readable.
if (!customElements.get('pure-welcome-cards')) {
  customElements.define('pure-welcome-cards', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.layout423_row-2');
      if (!this.grid || !window.ResizeObserver) return;
      this.measure = () => {
        const cards = [...this.grid.querySelectorAll('.layout423_card')];
        const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
        const available = this.grid.clientWidth - gap * (cards.length - 1);
        for (const card of cards) {
          const style = getComputedStyle(card);
          const width = available * 0.5 / (0.7 + 0.5 * (cards.length - 1));
          card.style.setProperty('--welcome-text-width', `${Math.max(0, width - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight))}px`);
        }
        for (const card of this.grid.querySelectorAll('.layout423_card')) {
          const note = card.querySelector('.layout423_card-content-bottom-2');
          card.style.setProperty('--welcome-note-height', `${note?.getBoundingClientRect().height || 0}px`);
        }
        this.grid.setAttribute('data-welcome-cards-ready', '');
      };
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this.grid);
      this.measure();
      document.fonts?.ready.then(() => { if (this.isConnected) this.measure(); });
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
